(function () {
  const isRTL = getComputedStyle(document.body).direction === "rtl";

  const OFFSET_CONFIG = {
    twoThree: { large: 60, medium: 66 },
    four:     { large: 65, medium: 70 },
    many:     { large: 65, medium: 70 },
    single:   { x: 0, y: -50 }
  };

  const SPEED = {
    CURVE_POWER: 4,
    RANGE_X: 1.2,
    RANGE_Y: 1.2
  };

  const MAX_MOBILE_Y = 7.72822;

  const easeOutPow = (t, n) => 1 - Math.pow(1 - t, n);
  const EPS = 0.0005;

  const reverseChildren = (parent) => {
    const kids = Array.from(parent.children);
    kids.reverse().forEach(kid => parent.appendChild(kid));
  };

  // Keep a registry so we can update all sections from ONE rAF tick
  const registry = [];
  let rafId = null;

  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      registry.forEach(item => item.update());
    });
  }

  const initScrollProducts = () => {
    const sections = document.querySelectorAll(".section-scroll-products");

    sections.forEach((section) => {
      if (section.classList.contains("scroll_initialized")) return;
      section.classList.add("scroll_initialized");

      const parent    = section.querySelector(".scroll-products__container");
      const child     = section.querySelector(".scroll-products");
      const innerDiv  = child && child.querySelector(".scroll-products__products");
      const productCard = section.querySelector(".scroll-products__item");
      const wrapper   = section.querySelector(".scroll-products__wrapper");

      if (!parent || !child || !innerDiv) return;

      // Encourage stable compositing in Safari
      innerDiv.style.willChange = "transform";
      innerDiv.style.transform = "translate3d(0,0,0)";

      // mobile: reverse card order once
      if (window.innerWidth < 990) {
        reverseChildren(innerDiv);
      }

      const productsCount = +child.dataset.productsCount;
      const isSingleProduct = productsCount == 1;

      // compute slideHeight once (avoid doing this on scroll)
      const childBefore = window.getComputedStyle(child, "::before");
      const slideHeight = parseFloat(childBefore.height) || 0;

      const updateMinHeight = () => {
        if (productCard && wrapper) {
          wrapper.style.maxHeight = `${productCard.offsetHeight}px`;
          let productCardHeight = productCard.offsetHeight + 96;
          if (productCardHeight < slideHeight) productCardHeight = slideHeight;
          child.style.minHeight = `${productCardHeight}px`;
        }
      };
      updateMinHeight();

      const update = () => {
        const parentRect = parent.getBoundingClientRect();
        const childRect  = child.getBoundingClientRect();

        const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

        const startScroll = parentRect.top + scrollY;
        const endScroll   = parentRect.bottom - childRect.height + scrollY;

        const isSmallScreen  = window.innerWidth < 750;
        const isMediumScreen = window.innerWidth < 900;

        const denom = (endScroll - startScroll) || 1;
        const raw = (scrollY - startScroll) / denom;
        const scrolled = Math.min(Math.max(raw, 0), 1);

        const eased = easeOutPow(scrolled, SPEED.CURVE_POWER);
        const p = (scrolled > 1 - EPS) ? 1 : eased;

        let translateY;
        let translateX = -50;

        if (isSmallScreen) {
          const startY = MAX_MOBILE_Y;
          const endY   = -115;
          translateY = startY + (endY - startY) * p;
          if (translateY < endY) translateY = endY;
        } else {
          if (isSingleProduct) {
            translateX = OFFSET_CONFIG.single.x;
            translateY = (OFFSET_CONFIG.single.y * SPEED.RANGE_Y) * p;
          } else {
            translateY = -50;
            const amplify = SPEED.RANGE_X;

            if (productsCount > 4) {
              const base = (isMediumScreen ? OFFSET_CONFIG.many.medium : OFFSET_CONFIG.many.large) * amplify;
              translateX = base - base * p;
            } else if (productsCount === 4) {
              const base = (isMediumScreen ? OFFSET_CONFIG.four.medium : OFFSET_CONFIG.four.large) * amplify;
              translateX = base - base * p;
            } else {
              const base = (isMediumScreen ? OFFSET_CONFIG.twoThree.medium : OFFSET_CONFIG.twoThree.large) * amplify;
              translateX = base - base * p;
            }
          }
        }

        const x = (isRTL && !isSmallScreen) ? -translateX : translateX;

        // translate3d tends to be more stable in Safari
        innerDiv.style.transform = `translate3d(${x}%, ${translateY}%, 0)`;
      };

      // register this section’s updater
      registry.push({ update, updateMinHeight });

      // initial paint
      update();
    });

    // Ensure we only bind these ONCE
    if (!window.__scrollProductsBound) {
      window.__scrollProductsBound = true;

      window.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", () => {
        registry.forEach(item => item.updateMinHeight());
        scheduleUpdate();
      }, { passive: true });
    }
  };

  initScrollProducts();
  document.addEventListener("shopify:section:load", () => initScrollProducts());
})();